import { API, graphqlOperation} from "aws-amplify"
import { listCampaigns, machineByOffice, listOutboxs, listDeliverabless, listCompanys, listEmployees } from '../graphql/queries'

export async function fetchAllCompanys() {
  let items = []
  let nextToken = null
  do {
    const res = await API.graphql(graphqlOperation(listCompanys, { limit: 1000, nextToken }))
    const data = res.data.listCompanys
    items = items.concat(data.items)
    nextToken = data.nextToken
  } while (nextToken)
  const json = JSON.stringify(items)
  console.log(`[fetchAllCompanys] 件数: ${items.length}件, サイズ: ${json.length} bytes`)
  return items
}

export async function fetchAllActiveEmployees() {
  let items = []
  let nextToken = null
  do {
    const res = await API.graphql(graphqlOperation(listEmployees, { limit: 1000, nextToken }))
    const data = res.data.listEmployees
    items = items.concat(data.items.filter(item => item.UserPoolID !== '000000000'))
    nextToken = data.nextToken
  } while (nextToken)
  const json = JSON.stringify(items)
  console.log(`[fetchAllActiveEmployees] 件数: ${items.length}件, サイズ: ${json.length} bytes`)
  return items
}

export async function fetchAllDeliverabless() {
  let items = []
  let nextToken = null
  do {
    const res = await API.graphql(graphqlOperation(listDeliverabless, { limit: 1000, nextToken }))
    const data = res.data.listDeliverabless
    items = items.concat(data.items)
    nextToken = data.nextToken
  } while (nextToken)
  const json = JSON.stringify(items)
  console.log(`[fetchAllDeliverabless] 件数: ${items.length}件, サイズ: ${json.length} bytes`)
  return items
}

export async function fetchAllOutboxs() {
  let items = []
  let nextToken = null
  do {
    const res = await API.graphql(graphqlOperation(listOutboxs, { limit: 1000, nextToken }))
    const data = res.data.listOutboxs
    items = items.concat(data.items)
    nextToken = data.nextToken
  } while (nextToken)
  const json = JSON.stringify(items)
  console.log(`[fetchAllOutboxs] 件数: ${items.length}件, サイズ: ${json.length} bytes`)
  return items
}

export async function fetchAllMachineByOffice(OfficeID, filter = null) {
  let items = []
  let nextToken = null
  do {
    const params = { OfficeID, limit: 1000, nextToken }
    if (filter) params.filter = filter
    const res = await API.graphql(graphqlOperation(machineByOffice, params))
    const data = res.data.machineByOffice
    items = items.concat(data.items)
    nextToken = data.nextToken
  } while (nextToken)
  const json = JSON.stringify(items)
  console.log(`[fetchAllMachineByOffice] OfficeID: ${OfficeID}, 件数: ${items.length}件, サイズ: ${json.length} bytes`)
  return items
}

export default {
    methods: {
        getNow: function() {
          var now = new Date();
          var yyyy = now.getFullYear();
          var mm = ("00" + (now.getMonth()+1)).slice(-2);
          var dd = ("00" + now.getDate()).slice(-2);
          var hh = ("00" + now.getHours()).slice(-2);
          var min = ("00" + now.getMinutes()).slice(-2);
          var ss = ("00" + now.getSeconds()).slice(-2);
          var today = yyyy + "-" + mm + "-" + dd + "T" + hh + ":" + min + ":" + ss + ".000+09:00";
          return today
        },
        getAfterDay: function(days) {
          var now = new Date();
          now.setDate( now.getDate() + days );
          var yyyy = now.getFullYear();
          var mm = ("00" + (now.getMonth()+1)).slice(-2);
          var dd = ("00" + now.getDate()).slice(-2);
          var hh = "23";
          var min = "59";
          var ss = "59";
          var afterDay = yyyy + "-" + mm + "-" + dd + "T" + hh + ":" + min + ":" + ss + ".000+09:00";
          return afterDay
        },
        getQuoteValidityAt: function() {
          var now = new Date();
          var quoteValidityAt = new Date(now.getFullYear(), now.getMonth() + 3, 0); // +3:翌々月

          var yyyy = quoteValidityAt.getFullYear();
          var mm = ("00" + (quoteValidityAt.getMonth()+1)).slice(-2);
          var dd = ("00" + quoteValidityAt.getDate()).slice(-2);
          var hh = "23";
          var min = "59";
          var ss = "59";
          var _quoteValidityAt = yyyy + "-" + mm + "-" + dd + "T" + hh + ":" + min + ":" + ss + ".000+09:00";
          return _quoteValidityAt
        },
        toBoolean: function (data) {
            return data.toLowerCase() === 'true';
        },
        getAnalizeItemFee: function(item, ratio, rounding){
//          console.log("getAnalizeItemFee", {Price:item.Price, RegularPrice:item.RegularPrice, ratio:ratio, rounding:rounding})
            let price = Number(item.Price)
            let regularPrice = Number(item.RegularPrice)
            let fee = price
            // 定価が定義されていない=得意先ホルダで上書きされていない場合
            // 得意先の掛け率で割掛け
            // 得意先ホルダで値引かれている場合は割かけ市内
            if(!regularPrice) {
              switch (rounding){
                case "切捨":
                  fee = Math.floor(price * ratio)
                  break
                case "四捨五入": // ラミネート加工 1700円
                  fee = Math.round(price * ratio)
                  break
                default: //"切上"
                  fee = Math.ceil(price * ratio)
                  break
              }
            }
//            console.log("getAnalizeItemFee", {Price:item.Price, RegularPrice:item.RegularPrice, ratio:ratio, rounding:rounding, Fee:fee})
            return fee
          },
          getFilterFee: function(filter) {
            let filterFee
            switch (filter) {
              case "003": // ラミネート加工なし 600円
                filterFee = 600;
                break
              case "002": // ラミネート加工 1700円
                filterFee = 1700;
                break
              default: // case 001 なし
                filterFee = 0;
                break
            }
            return filterFee
          },
          getSurplusFee: function(surplus) {
            let surplusFee = 0
            switch (surplus) {
              case "1": // 希望
                surplusFee = 1800
                break
              default: // case "0" 希望しない
                surplusFee = 0
                break
            }
            return surplusFee
          },
          getDiscount: async function(analizeFee) {
//            console.log("getDiscount analizeFee", analizeFee)

            var now = new Date();
            var yyyy = now.getFullYear();
            var mm = ("00" + (now.getMonth()+1)).slice(-2);
            var dd1 = ("00" + (now.getDate())).slice(-2);
            var dd2 = ("00" + (now.getDate())).slice(-2);
            var today1 = yyyy + "-" + mm + "-" + dd1 + "T00:00:00.000";
            var today2 = yyyy + "-" + mm + "-" + dd2 + "T23:59:59.999";
//            console.log("getDiscount to/from", today1 + "/" + today2)

            let discountFilter = {
              and: [{
                To:{
                  gt: today1
                },
                From:{
                  lt: today2
                },
              }
              ]
            }
            let _campaigns = await API.graphql(graphqlOperation(listCampaigns, {limit: 100, filter:discountFilter}))
            if(_campaigns.data.listCampaigns.items) {
              let campaigns = _campaigns.data.listCampaigns.items
              // 開始日でソート
              campaigns.sort(function(a,b){
                if(a.From > b.From) return -1;
                if(a.From < b.From) return 1;
                return 0;
              });
              console.log("campaign:",campaigns);
  //            for (const campaign of campaigns) {
  //              console.log("campaign:",campaign.From + "-" + campaign.To + " " + campaign.Name);
  //            }
    
              let discount = 0
              let discountSetting = JSON.parse(campaigns[0].Discount)
              let From = campaigns[0].From
              let To = campaigns[0].To
              if((analizeFee >= 10001) && (analizeFee <= 30000)) { //1000円
                discount = discountSetting.cat1
              }else if((analizeFee >= 30001) && (analizeFee <= 50000)) { //3000円
                discount = discountSetting.cat2
              }else if(analizeFee >= 50001) { //5000円
                discount = discountSetting.cat3
              }else { //0円（割引なし）
                discount = {code: "", discount:0}
              }
              discount["From"] = From
              discount["To"] = To
              return discount
            }
          },
          getApplicationStatus: function (status, mode) {
            let style={}
            if(mode == 1) {
                switch(status){
                    case "quoteIssued":
                        style = {text:"見積書 発行済み", color:"green", class:"white--text py-0", label:true, outlined:false, style:{width:"140px"}, message:"お見積書を印刷して下さい。お見積り内容でご依頼いただく場合は「お見積り内容で申し込む」をクリックしてください。"}
                        break
                    case "quoteRequest":
                        style = {text:"見積相談中",     color:"red", class:"red--text py-0", label:true, outlined:true, style:{width:"140px"}, message:"お見積りに関するご相談内容を確認中です。しばらくおまちください。"}
                        break
                    case "quoteReturn":
                        style = {text:"見積書 回答確認", color:"red", class:"white--text py-0", label:true, outlined:false, style:{width:"140px"}, message:"ご相談の内容でお見積書を作成しました。お見積り内容でご依頼いただく場合は「お見積り内容で申し込む」をクリックしてください。"}
                        break
                    case "quoteApplied":
                        style = {text:"正式依頼済み", color:"green", class:"white--text py-0", label:true, outlined:true, style:{width:"140px"}, message:"このお見積書は正式にご依頼済みです。"}
                        break
                    case "quoteCanceled":
                        style = {text:"見積キャンセル", color:"gray", class:"gray--text py-0", label:true, outlined:true, style:{width:"140px"}, message:"このお見積書はキャンセルされました。"}
                        break
                    case "Received": //オレンジ
                        style = {text:"ご予約中", color:"grey darken-4", class:"black--text py-0", label:false, outlined:true, style:{width:"140px"},}
                        break
                    case "Retry": //オレンジ（再連携ステータス）
                      style = {text:"ご予約中", color:"grey darken-4", class:"black--text py-0", label:false, outlined:true, style:{width:"140px"},}
                      break
                    case "Reserve": //オレンジ
                        style = {text:"ご予約中", color:"grey darken-4", class:"black--text py-0", label:false, outlined:true, style:{width:"140px"},}
                        break
                    case "Applied":
                        style = {text:"受付済み", color:"green", class:"white--text py-0", label:false, outlined:false, style:{width:"140px"},}
                        break
                    case "Delivered":
                        style = {text:"納品済み", color:"blue darken-2", class:"white--text py-0", label:false, outlined:false, style:{width:"140px"},}
                        break
                    case "ご予約中":
                        style = {text:"ご予約中", color:"grey darken-4", class:"black--text py-0", label:false, outlined:true, style:{width:"140px"},}
                        break
                    case "受付済み":
                        style = {text:"受付済み", color:"green", class:"white--text py-0", label:false, outlined:false, style:{width:"140px"},}
                        break
                    case "納品済み":
                        style = {text:"納品済み", color:"blue darken-2", class:"white--text py-0", label:false, outlined:false, style:{width:"140px"},}
                        break
                    default:
                        style = {text:status, color:"grey darken-4", class:"white--text py-0", style:{width:"140px"},}
                        break
                }
            }else {
                switch(status){
                    case "quoteIssued":
                        style = {text:"見積書 発行済み", color:"green", class:"white--text py-0", label:true, outlined:true, style:{width:"140px"}}
                        break
                    case "quoteRequest":
                        style = {text:"見積相談 依頼",     color:"yellow", class:"black--text py-0", label:true, outlined:false, style:{width:"140px"}, }
                        break
                    case "quoteReturn":
                        style = {text:"見積書 回答済み", color:"red", class:"white--text py-0", label:true, outlined:true, style:{width:"140px"},message:"お見積り回答済みです"}
                        break
                    case "quoteApplied":
                        style = {text:"正式依頼済み", color:"green", class:"green--text py-0", label:true, outlined:true, style:{width:"140px"},}
                        break
                    case "quoteCanceled":
                        style = {text:"見積キャンセル", color:"gray", class:"py-0", label:true, outlined:false, style:{width:"140px"},}
                        break
                    case "Received":
                        style = {text:"受注連携待ち", color:"grey darken-2", class:"black--text py-0", label:false, outlined:true, style:{width:"140px"},}
                        break
                    case "Retry": //（再連携）
                        style = {text:"受注連携待ち", color:"grey darken-2", class:"black--text py-0", label:false, outlined:true, style:{width:"140px"},}
                        break
                    case "Reserve":
                      style = {text:"受注連携済み", color:"grey darken-4", class:"black--text py-0", label:false, outlined:true, style:{width:"140px"},}
                      break
                    case "Applied":
                        style = {text:"受付済み", color:"green", class:"white--text py-0", label:false, outlined:false, style:{width:"140px"},}
                        break
                    case "Delivered":
                        style = {text:"納品済み", color:"blue darken-2", class:"white--text py-0", label:false, outlined:false, style:{width:"140px"},}
                        break
                    case "ご予約中":
                        style = {text:"ご予約中", color:"grey darken-4", class:"black--text py-0", label:false, outlined:true, style:{width:"140px"},}
                        break
                    case "受付済み":
                        style = {text:"受付済み", color:"green", class:"white--text py-0", label:false, outlined:false, style:{width:"140px"},}
                        break
                    default:
                        style = {text:status, color:"black", class:"white--text py-0", style:{width:"140px"},}
                        break
                }
            }
            return style

        },
        getFilterString: function(filter) {
            switch (filter) {
              case "003": // ラミネート加工なし 600円
                return "フィルター送付（通常）"
              case "002": // ラミネート加工 1700円
                return "フィルター送付（ラミネート加工）"
              default: // case 001 なし
                return "フィルター不要"
            }
          },
          getSurplusString: function(surplus) {
            switch (surplus) {
              case "1": // 希望
                return "サンプル返却"
              default: // case "0" 希望しない
                return "サンプル返却不要"
            }
          },
          getOpinionString: function(opinion) {
            if(opinion) {
              return "分析診断内容を相談する"
            }else {
              return "しない"
            }
      
          },


          getFilterString2: function(filter) {
            switch (filter) {
              case "003": // ラミネート加工なし 600円
                return "ラミネート加工なし"
              case "002": // ラミネート加工 1700円
                return "ラミネート加工あり"
              default: // case 001 なし
                return "不要"
            }
          },
          getSurplusString2: function(surplus) {
            switch (surplus) {
              case "1": // 希望
                return "返却希望"
              default: // case "0" 希望しない
                return "不要"
            }
          },

          getBytes: function (str) {
            return encodeURI(str).replace(/%../g, "*").length
          },
          
          isTime(value) {
            let _value = String(value)
            return _value.match(/^([0-9]\d*):([0-5][0-9])$/)
          },

          timeToDecimal(value) {
            let hh = Number(value.split(":")[0])
            let mm = Number(value.split(":")[1])
//            let _mm = mm / 60
            let _mm  = Math.round( mm / 60 * Math.pow( 10, 1 ) ) / Math.pow( 10, 1 ) ;
//            console.log("time to decimal mm:", mm + "->" + _mm)
            return hh + _mm
          },

          timeToMin(value) {
            let hh = Number(value.split(":")[0])
            let mm = Number(value.split(":")[1])
            return (hh * 60) + mm
          },
/*
          decimalToTime(value) {
            let deci = String(value)
            let hh = Number(deci.split(".")[0])
            let _mm = 0.0
            if(deci.split(".")[1]) {
              let a = String(deci.split(".")[1] + "00").substring(0,2)
              _mm = Number(a) / 100
//              _mm  = Math.floor( Number(a) / 100 * Math.pow( 10, 2 ) ) / Math.pow( 10, 2 ) ;
//              console.log("decimal To Time mm:", a + "->" + _mm)
            }

//            let mm = 60 * _mm
            let mm  = Math.floor( 60 * _mm * Math.pow( 10, 0 ) ) / Math.pow( 10, 0 ) ;
            let strmm = ""
            if(mm < 10) {
              strmm = "0" + String(mm)
            }else {
              strmm = String(mm)
            }

            let result = String(hh) + ":" + strmm
            return result
          },
*/

          decimalToMin(value) {
            let deci = String(value)
            let hh = Number(deci.split(".")[0]) * 60
            let mm = 0
            if(deci.split(".")[1]) {
              mm = deci.split(".")[1] / 10 * 60
            }
            console.log("decimalToMin %f -> %d", value,hh + mm)

            return hh + mm

          },

          minToTime(value) {
            let hh = Math.floor(value/60)
            console.log("hour %d", (hh*60))
            let _mm = value - (hh*60)
            let mm = ( '00' + _mm ).slice( -2 );
            console.log("minToTime %f -> %d:%d", value,hh,mm)
            let result = hh + ":" + mm
            return result
          },
/*
          decimalToTime(value) {
            let deci = String(value)
            let hh = Number(deci.split(".")[0])
            let _mm = 0.0
            if(deci.split(".")[1]) {
              let a = String(deci.split(".")[1] + "00").substring(0,2)
              _mm = Number(a) / 60
            }

            let mm  = Math.floor( 60 * _mm * Math.pow( 10, 0 ) ) / Math.pow( 10, 0 ) ;
            let strmm = ""
            if(mm < 10) {
              strmm = "0" + String(mm)
            }else {
              strmm = String(mm)
            }

            let result = String(hh) + ":" + strmm
            return result
          },
*/          
          calcTime(time, value) {
            let a = 0
            let b = 0
//            let istime = false
            let result = ""
            //加算対象が時刻表記（hh:mm）の場合
            if(this.isTime(time)) {
              a = this.timeToMin(time)
              if(this.isTime(value)) {
                b = this.timeToMin(value)
              }else {
                b = this.decimalToMin(value)
              }
              result = this.minToTime(a + b)
              console.log("calcTime %s + %s -> %s", time, value, result)
              return result

            //加算対象が小数表記（99.9）の場合、数値変換
            }else {
              a = Number(time)
              if(this.isTime(value)) {
                b = this.timeToDecimal(value)
              }else {
                b = Number(value)
              }
              result = a + b
              console.log("calcTime %s + %s -> %s", time, value, result)
              return result
            }
/*
            //加算値が時刻表記（hh:mm）の場合、分に変換
            if(this.isTime(value)) {
              b = this.timeToMin(value)
              console.log("value: %s - > %f", value, b)
            }else if(!isNaN(value)){
              b = Number(value)
            }else {
              b = this.timeToMin(value)
              return time
            }

            if(istime) {
              result = this.decimalToTime(a + b)
            }else {
//              result = a + b
              result  = Math.round( (a + b) * Math.pow( 10, 1 ) ) / Math.pow( 10, 1 ) ;
            }
            return result
*/

          }
    }
}